const overrides = {
    field: {
        yearBuilt: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT', 'NC', 'TN', 'VA', 'NH']
                }
            }
        },
        numberOfUnits: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT', 'NC', 'TN', 'VA', 'NH']
                }
            }
        },
        extereriorWallFinish: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT', 'NC', 'TN', 'VA', 'NH']
                }
            }
        },
        hasDogInHome: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT', 'NC', 'TN', 'VA', 'NH']
                }
            }
        },
        highRiskDogBreedInd: {
            partner: {
                MSA: {
                    // IAP-5194, highRiskDogBreedInd not available for IL
                    states: ['IN', 'KY', 'OH', 'NJ', 'PA', 'UT', 'NC', 'TN', 'VA', 'NH']
                }
            }
        },
        primaryHeatingSystem: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT', 'NC', 'TN', 'VA', 'NH']
                }
            }
        }
    }
};
export default overrides;
